import { MenuItem } from '@ovComponents/2-component/menuItem/menuItem';
import { SelectField } from '@ovComponents/2-component/selectField/selectField';
import { TranslatableTextField } from '@ovComponents/2-component/translatableTextField/translatableTextField';
import { Grid, Switch } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../../../hooks/useLocalization';

export enum FieldRequiredType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  NOT_REQUIRED = 'NOT_REQUIRED',
  NOT_EDITABLE = 'NOT_EDITABLE',
}

export const BasicFieldEdit = ({
  option,
  options,
  setOptions,
  i,
  type,
}: {
  option: any;
  options: any;
  setOptions: (x: any) => void;
  i: number;
  type?: string;
}) => {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation('shared');
  const canShowNotEditableField = (): boolean =>
    [
      'PERSONAL_INFORMATION',
      'CUSTOM_FIELDS_DISPLAY',
      'RELATIONSHIP_INFORMATION',
      'INCOME_ASSETS_AND_DEBTS',
      'PERSONS_OF_INTEREST',
      'RESIDENCY_INFORMATION',
      'EMPLOYMENT_INFORMATION',
      'NON_INDIVIDUAL_INFORMATION',
      'GOAL_INFORMATION',
      'EDIT_ACCOUNT',
      'GOAL_SUITABILITY',
      'SUITABILITY',
      'COMPLIANCE',
    ].includes(type ?? '');

  return (
    <Grid
      container
      spacing={1}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'end',
        mb: 2,
      }}
    >
      <Grid size={6}>
        <TranslatableTextField
          label={translateBackendString(option.label)}
          value={option.value.label}
          disabled={!option.value?.enabled}
          fullWidth
          onChange={(value) => {
            const newOptions = [...options];
            newOptions[i].value = { ...option.value, label: value };
            setOptions(newOptions);
          }}
        />
      </Grid>
      <Grid size={4}>
        <SelectField
          label={t('required')}
          value={option.value.required}
          disabled={!option.value?.enabled}
          fullWidth
          onChange={(e: any) => {
            const newOptions = [...options];
            newOptions[i].value = { ...option.value, required: e.target.value };
            setOptions(newOptions);
          }}
        >
          <MenuItem value={FieldRequiredType.ERROR}>{t('error')}</MenuItem>
          <MenuItem value={FieldRequiredType.WARNING}>{t('warning')}</MenuItem>
          <MenuItem value={FieldRequiredType.NOT_REQUIRED}>
            {t('notRequired')}
          </MenuItem>
          {canShowNotEditableField() && (
            <MenuItem value={FieldRequiredType.NOT_EDITABLE}>
              {t('notEditable')}
            </MenuItem>
          )}
        </SelectField>
      </Grid>
      <Grid
        size={2}
        sx={{
          justifyContent: 'center',
          display: 'flex',
          mt: 2,
        }}
      >
        <Switch
          sx={{ mb: 1 }}
          checked={option.value?.enabled}
          onChange={(e: any) => {
            const newOptions = [...options];
            newOptions[i].value = {
              ...option.value,
              enabled: e.target.checked,
            };
            setOptions(newOptions);
          }}
        ></Switch>
      </Grid>
    </Grid>
  );
};
